import risingPopSound from "@/assets/sounds/rising-pops.mp3";
import chimeSound from "@/assets/sounds/chime.mp3";
import spoon from "@/assets/sounds/spoon.mp3";

const sounds = {
  risingPopSound: new Audio(risingPopSound),
  chimeSound: new Audio(chimeSound),
  spoonSound: new Audio(spoon),
};

const playSound = (sound: HTMLAudioElement, volume = 0.5) => {
  sound.volume = volume;
  sound.play().catch((error) => {
    console.error("Error playing sound:", error);
  });
};

export const playRisingPopSound = (volume = 0.5) =>
  playSound(sounds.risingPopSound, volume);

// Debounce tracking — prevents overlapping sounds from burst arrivals
const DEBOUNCE_MS = 500;
let lastChimeTime = 0;
let lastSpoonTime = 0;
let lastBeepTime = 0;

export const playChime = (volume = 0.5) => {
  const now = Date.now();
  if (now - lastChimeTime < DEBOUNCE_MS) return;
  lastChimeTime = now;
  playSound(sounds.chimeSound, volume);
};

export const playSpoon = (volume = 0.5) => {
  const now = Date.now();
  if (now - lastSpoonTime < DEBOUNCE_MS) return;
  lastSpoonTime = now;
  playSound(sounds.spoonSound, volume);
};

let beepAudioContext: AudioContext | null = null;

export const playBeep = () => {
  const now = Date.now();
  if (now - lastBeepTime < DEBOUNCE_MS) return;
  lastBeepTime = now;

  try {
    if (!beepAudioContext || beepAudioContext.state === "closed") {
      beepAudioContext = new AudioContext();
    }

    beepAudioContext.resume().then(() => {
      if (!beepAudioContext) return;
      const oscillator = beepAudioContext.createOscillator();
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(880, beepAudioContext.currentTime);

      oscillator.connect(beepAudioContext.destination);
      oscillator.start();

      setTimeout(() => {
        oscillator.stop();
        oscillator.disconnect();
      }, 800);
    });
  } catch (error) {
    console.error("Error in playBeep:", error);
  }
};
